export class BmsMeterExchangeInfo {
  ok : boolean;
  oldMeterInfo : string;
  newMeterInfo : string;
  endValue : number;
  startValue : number;
  unit : string;
  exchangeDate : Date;
  exchangeDateString : Date;
  message : string;
}

export class BmsMeterExchangesImportResult {
  ok : boolean;
  message : string;
  okCount : number;
  errorCount : number;
  meterExchanges : BmsMeterExchangeInfo[];
  preview : boolean;
}
